import { makeVar } from "@apollo/client";

export enum Status {
  BOOTSTRAP_IN_PROGRESS = "BOOTSTRAP_IN_PROGRESS",
  BOOTSTRAP_SUCCESS = "BOOTSTRAP_SUCCESS",
  BOOTSTRAP_ERROR = "BOOTSTRAP_ERROR",
}

export const statusVar = makeVar<Status>(Status.BOOTSTRAP_IN_PROGRESS);
